import React from 'react';
import { HomeContainer } from './home.container';
import {
  FlexStretchItem,
  FullHeightContainer,
  VerticalContainer,
} from '../../shared/design';

export const HomeView: React.FunctionComponent = () => {
  return (
    <FlexStretchItem collapseHeight={true}>
      <FullHeightContainer as={VerticalContainer} isScrollable={true}>
        <HomeContainer />
      </FullHeightContainer>
    </FlexStretchItem>
  );
};
